<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
            <el-form-item label="路径名称" prop="name">
                <el-input style="width:480px;" v-model="form.name" placeholder="请输入路径名称"></el-input>
            </el-form-item>
            <el-form-item label="关联问卷" prop="questionnaireId">
                <el-select v-model="form.questionnaireId" @change="handleQuestionnaireChange">
                    <el-option v-for="(questionnaire, index) in questionnaires" :key="index" :label="questionnaire.name"
                        :value="questionnaire.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="条件逻辑配置" prop="questions">
                <el-button icon="el-icon-plus" type="text" @click="handleAdd">添加逻辑</el-button>
                <div v-for="(item, index) in form.questions" :key="index" style="margin-bottom: 10px">
                    <el-select v-model="item.questionId">
                        <el-option v-for="question in questions" :key="question.id" :value="question.id"
                            :label="question.questionText"></el-option>
                    </el-select>
                    <el-select v-model="item.optionValue">
                        <el-option v-for="(option, index) in getOptions(item.questionId)" :key="index" :value="option"
                            :label="option"></el-option>
                    </el-select>
                    <el-button type="text" icon="el-icon-delete" style="color: red;margin-left: 10px;"
                        @click="handleDelOption(item)"></el-button>
                </div>
            </el-form-item>
            <el-form-item label="配置说明" prop="description">
                <el-input type="textarea" v-model="form.description" :rows="4"></el-input>
            </el-form-item>
            <el-form-item label="结果配置">
                <el-select v-model="form.productId" @change="handleProductChange" placeholder="选择产品" clearable>
                    <el-option v-for="product in products" :key="product.id" :value="product.id"
                        :label="product.productName"></el-option>
                </el-select>
                <el-select v-model="form.batteryId" placeholder="选择电池" clearable>
                    <el-option v-for="battery in butterys" :key="battery.id" :value="battery.id"
                        :label="battery.name"></el-option>
                </el-select>
                <span>数量</span>
                <el-input-number v-model="form.batteryCount"></el-input-number>
            </el-form-item>
            <el-form-item label="待载设备配置">
                <el-select v-model="form.loadDeviceIds" placeholder="选择设备" clearable multiple style="width: 100%;">
                    <el-option v-for="item in devices" :key="item.id" :value="item.id"
                        :label="item.publicName"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button @click="$router.back()">取消</el-button>
                <el-button type="primary" @click="handleSave">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { add, edit, detail } from "@/api/path";
import { list, detail as qDetail } from "@/api/questionnaire";
import { page } from "@/api/product";
import { list as bList } from "@/api/battery";
import { page as dPage } from "@/api/device";
export default {
    data() {
        return {
            id: null,
            form: {
                name: "",
                questions: [],
                description: "",
                productId: null,
                batteryId: null,
                batteryCount: 1,
                loadDeviceIds: []
            },
            questionnaires: [],
            questions: [],
            products: [],
            butterys: [],
            devices: [],
            rules: {

            }
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        this.getQuestionnaires();
        this.getProducts();
        this.getDevices();
        if (this.id) {
            this.getDetail();
        }
    },
    methods: {
        handleAdd() {
            this.form.questions.push({ questionId: "", optionValue: "" });
        },
        getQuestionnaires() {
            list().then(({ code, data }) => {
                if (code == 200) {
                    this.questionnaires = data;
                }
            })
        },
        getProducts() {
            page({ page: 1, size: 9999 }).then(({ code, data }) => {
                if (code == 200) {
                    this.products = data.records;
                }
            })
        },
        getDevices() {
            dPage({ page: 1, size: 9999 }).then(({ code, data }) => {
                if (code == 200) {
                    this.devices = data.records;
                }
            })
        },
        getButterys(productId) {
            bList({ productId }).then(({ code, data }) => {
                if (code == 200) {
                    this.butterys = data;
                }
            })
        },
        handleProductChange(productId) {
            this.getButterys(productId);
        },
        handleDelOption(option) {
            this.form.questions = this.form.questions.filter(item => item !== option);
        },
        getOptions(questionId) {
            const cur = this.questions.find(item => item.id == questionId);
            return cur ? cur.optionValues : [];
        },
        handleQuestionnaireChange(questionId) {
            qDetail(questionId).then(({ code, data }) => {
                if (code == 200) {
                    this.questions = data.questions;
                }
            })
        },
        getDetail() {
            detail(this.id).then(({ code, data }) => {
                if (code == 200) {
                    this.form = {
                        ...data,
                        loadDeviceIds: data.loadDeviceIds.map(item => +item)
                    };
                    this.handleProductChange(this.form.productId);
                    this.handleQuestionnaireChange(this.form.questionnaireId);
                }
            })
        },
        handleSave() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                const params = {
                    ...this.form
                }
                if (!this.id) {
                    add(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                } else {
                    params.id = this.id;
                    edit(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("修改成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                }
            })
        }
    }
}
</script>

<style></style>